// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2E7Lr","container":"styles_container__36-zo","title":"styles_title__38BOZ","wrapper":"styles_wrapper__2Jnub","answer":"styles_answer__3Os-Q"};